import type { ReactNode } from 'react'

import { cn } from '@/shared/lib/cn'

import { CompanySpine } from './CompanySpine'

export interface PageHeaderProps {
  title: string
  description?: ReactNode
  /** Migas de pan ya renderizadas (links). */
  breadcrumb?: ReactNode
  /** Acciones a la derecha: botones primarios y secundarios. */
  actions?: ReactNode
  /** Si la pantalla pertenece a una empresa, su hue pinta la espina del header. */
  companyHue?: number
  companyName?: string
  /** Tabs o barra de filtros pegada al header. */
  children?: ReactNode
  className?: string
}

export function PageHeader({
  title,
  description,
  breadcrumb,
  actions,
  companyHue,
  companyName,
  children,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('hairline-b bg-surface-1', className)}>
      <div className="flex items-stretch gap-3 px-4 py-3">
        {companyHue !== undefined ? (
          <CompanySpine hue={companyHue} label={companyName} className="min-h-[36px]" />
        ) : null}

        <div className="flex min-w-0 flex-1 flex-col gap-1">
          {breadcrumb ? <div className="text-2xs text-text-3">{breadcrumb}</div> : null}
          <h1 className="truncate text-lg text-text-1">{title}</h1>
          {description ? <p className="text-xs text-text-2">{description}</p> : null}
        </div>

        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>

      {children ? <div className="px-4 pb-2">{children}</div> : null}
    </header>
  )
}
